import React, { Suspense, lazy } from "react";

// The Lottie player and its animation data are loaded on demand, so they stay
// out of the main bundle (LoadingView imports this file on every page).
const BookAnimation = lazy(() => import("./BookAnimation"));

export const BookLoader = () => {
    return <Suspense fallback={<div style={{ width: 200, height: 200 }} />}>
        <BookAnimation />
    </Suspense>
}
